import React from "react";

const UsernameAndLogout = (props) => (
    <div style={{ float: "right", padding:" 0.5em 1em" }} >
        <span className="x-username"
              style={{
            color: "white",
            fontStyle: "italic",
            paddingRight: "1em"
        }}>{props.username}</span>
        <button type="button" className="x-logout-button pure-button pure-button-primary"
                onClick={ props.onLogout }>Logout</button>
    </div>
);

UsernameAndLogout.propTypes = {
    onLogout: React.PropTypes.func,
    username: React.PropTypes.string
};

export default UsernameAndLogout;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/components/UsernameAndLogout.js
 **/